<template>
  <article class="voice-advice__audit iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <!--步骤看板-->
       <ApplyStep :stepData="stepData" />
      <!-- <BulletinBoard style="height: 180px;" v-for="(item, index) in boardList" :key="index" :data="item"></BulletinBoard> -->
      <VoicePanel title="心声建议"></VoicePanel>
      <FormLayout 
        :readOnly="readOnly"
        :model="personAdviceModel" 
        :list="personAdviceFormOptions">
      </FormLayout>
      <LayoutTitle title="附件信息">
        <FormLayout
          ref="attachmentInfo" 
          :model="attachmentModel"
          :list="attachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <LayoutTitle title="审核信息">
        <FormLayout
          ref="theSecondAttachmentInfo" 
          :model="theSecondAttachmentModel"
          :list="theSecondAttachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <DragTable
        class="iv-m-t-24 iv-p-b-40"
        noUrl
        noSearch
        :showEdit="false"
        :showDelete="false"
        :showSelect="false" 
        :showPage="false"
        ref="DragTable" 
        :immediateForce="true" 
        :columns="columns" 
        :tableData="tableData">
      </DragTable>
      <FooterOperator>
        <div class="iv-text-center">
          <Button 
            class="iv-m-r-8" 
            type="submit"
            @click="handleSubmitAudit">
            审核
          </Button>
          <Button 
            type="back" 
            @click="handleClickBack">
            返回
          </Button>
        </div>
      </FooterOperator>
    </div>
  </article>
</template>

<script>
import VoicePanel from '../components/panel.vue'
import formOptions, { attachmentOptions, theSecondAttachmentOptions } from './formOptions'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import FooterOperator from '@/components/footer-operator'
import DragTable from '@/components/drag-table-inline'
import BulletinBoard from '@/components/bulletin-board-list'
import columns from './columns'
import { timeFormat } from '@/utils'
import ApplyStep from '../components/apply-step.vue'
export default {
  name: 'VoiceAdviceAudit',
  components: { 
    ApplyStep,
    VoicePanel, 
    FormLayout, 
    LayoutTitle, 
    FooterOperator,
    DragTable,
    BulletinBoard
  },
  data () {
    return {
      personAdviceFormOptions: [],
      personAdviceModel: {},
      attachmentOptions: [],
      attachmentModel: {},
      theSecondAttachmentOptions: [],
      theSecondAttachmentModel: {},
      auditName: sessionStorage.getItem('userName'),
      auditOrgName: sessionStorage.getItem('fullName'),
      auditTime: timeFormat(new Date()),
      getTypeCodesOptionList: [],
      columns: [],
      tableData: [],
      voiceAdviceId: this.$route.query.voiceAdviceId,
      groupId: '',
      type: this.$route.query.type,
      readOnly: true,
      isLeader: false,
      stepData: [
        {
          step: 1,
          status: 'complete',
          title: '心声建议提交'
        },
        {
          step: 2,
          status: 'complete',
          title: '心声建议接收'
        },
        {
          step: 3,
          status: 'complete',
          title: '心声建议处理'
        },
        {
          step: 4,
          status: 'auditing',
          title: '处理结果审核'
        },
        {
          step: 5,
          status: 'wait',
          title: '心声建议反馈'
        }
      ]
    }
  },
  created () {
    // this.theSecondAttachmentModel.auditName = this.auditName
    // this.theSecondAttachmentModel.auditTime = this.auditTime
    if(this.voiceAdviceId) {
      Promise.all([this.isLeaderAduit()]).then((...params) => {
        if (params[0]) {
          Promise.all([this.getVoiceAdvice()]).then((...params) => {
            Promise.all([this.getHandleInfo()]).then((...params) => {
              this.getList()
              this.isPublic(this.isLeader)
            })
          })
        } else {
          Promise.all([this.getVoiceAdvice()]).then((...params) => {
            this.getList()
          })
        }
      })
      Promise.all([this.getlistAudit()]).then((...params) => {
        this.columns = columns.call(this)
      })
    }
    this.getTypeCodesList()
  },
  methods: {
    getList() {
      this.attachmentOptions = attachmentOptions.call(this)
      this.theSecondAttachmentOptions = theSecondAttachmentOptions.call(this)
    },
    isPublic(isLeader) {
      if (!isLeader) {
        let auditResultIndex = this.theSecondAttachmentOptions.findIndex(item => {
          return item[$field] === 'auditResult'
        })
        this.theSecondAttachmentOptions.splice(auditResultIndex + 1, 0, {
          type: 'Radio',
          title: '是否公开',
          colSpan: 6,
          [$field]: 'isPublic',
          optionList: [
            {
              label: '是',
              value: 'yes'
            },
            {
              label: '否',
              value: 'no'
            }
          ],
          rules: ['required']
        },)
      }
    },
    // 判断是否为上级领导
    isLeaderAduit () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/isLeaderAduit',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          this.isLeader = res
          resolve(res)
        })
      })
      
    },
    // 查询心声建议详情
    getVoiceAdvice () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url :'api-general/module/portal/voiceAdvice/get',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          this.personAdviceModel = res
          this.personAdviceModel.adviceTime = timeFormat(this.personAdviceModel.adviceTime)
          this.theSecondAttachmentModel.auditTime = this.auditTime
          this.theSecondAttachmentModel.auditOrgName = res.orgName
          this.theSecondAttachmentModel.auditName = res.userName
          this.groupId =this.personAdviceModel.fileInfo || this.getUuid()
          this.getActivityFiles(this.groupId)
          resolve(res)
        })})
    },
    // 心声建议处理信息获取
    getHandleInfo () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/getCurrentAuditUserInfo',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          this.theSecondAttachmentModel.auditOrgName = res.orgName
          resolve(res)
        })
      })
    },
    // 办理过程查询
    getlistAudit () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/listAudit',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          this.tableData = res
          resolve()
        })})
    },
    getTypeCodesList() {
      this.$ajax({
        url: 'api-general/module/portal/user/outGetList',
        method: 'GET',
        data: {
          dictCode: 'GG68',
          merge: false,
          bizLineCode: 'YWX03'
        }
      }).then(res => {
        res.data.data.forEach(item => {
          this.getTypeCodesOptionList.push({
            label: item.title,
            value: item.value
          })
        })
        this.personAdviceFormOptions = formOptions.call(this)
      })
    },
    handleSubmitAudit () {
      this.$refs.theSecondAttachmentInfo.validate((valid) => {
        if (!valid) {
          return this.$Message.error('校验未通过')
        }
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/audit',
          method: 'PUT',
          data: {
            auditResult: this.theSecondAttachmentModel.auditResult,
            isPublic: this.theSecondAttachmentModel.isPublic,
            auditContent: this.theSecondAttachmentModel.auditContent,
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          this.$Message.success('审核完成')
          this.$router.push({
            name: 'dealtList',
            query: {
              currentPage: this.$route.query.currentPage || 1,
              voiceCurrentPage: this.$route.query.voiceCurrentPage || 1,
              tabName: this.$route.query.tabName || ''
            }
          })
        })
      })
    },
    getActivityFiles (groupId) {
      this.$ajax({
        url: 'api-uum/file/listFilesByGroupId',
        method: 'GET',
        data: {
          isPage: false,
          groupId: groupId
        }
      }).then(({data}) => {
        this.$set(this.attachmentModel, 'fileInfo', data.data)
      })
    },
    downLoad (item) {
      let url = `api-uum/file/downloadFile?fileId=${item.fileId}&access_token=${sessionStorage.getItem('token')}`
      window.open(url)
    },
    handleClickBack () {
      this.$router.push({
        name: 'dealtList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          voiceCurrentPage: this.$route.query.voiceCurrentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-advice__audit {
  min-height: 100%;
  background-color: #fff;
}
</style>